import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import { Paragraph } from 'ckeditor5';
import { FileUpload } from 'primeng/fileupload';
import { environment } from '../../../../environments/environment';
import { PermissionsService } from '../../../services/permission.service';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../../editorconfig';

@Component({
  selector: 'app-eoi-master',
  standalone: false,
  templateUrl: './eoi-master.component.html',
  styleUrl: './eoi-master.component.scss'
})
export class EoiMasterComponent implements OnInit {
  eoiForm: FormGroup;
  rfpForm: FormGroup;
  socForm: FormGroup;
  sotrForm: FormGroup;

  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @ViewChild('editFileUpload') editFileUpload!: FileUpload;
  reqDoc: any[] = [];
  cols: any[] = [
    { field: 'name', header: 'Name', filterType: 'text' },
  ];
  EOIData: any;
  selectedType: any;
  showDialog: boolean = false;
  selectedItem: any;
  editMode: boolean = false;
  data: any[] = [];
  showDeleteDialog: boolean = false;
  // Radio selection: 'editor' = rich text, 'document' = file upload
  selectedFormat: 'editor' | 'document' | null = null;
  editorContent: string = '';
  // TinyMCE rich text editor (same as other components)
  init: EditorComponent['init'] = init;
  /** Same as init but readonly – used in View details so toolbar/menus show but content is not editable. */
  initReadonly: EditorComponent['init'] = { ...init, readonly: true };
  stepForm: FormGroup;
  documentTypes = [
    { label: 'EOI', value: 'eoi' },
    { label: 'SOC', value: 'soc' },
    { label: 'SOTR', value: 'sotr' },
    { label: 'RFP', value: 'rfp' }
  ];
  constructor(private fb: FormBuilder, private messageService: MessageService, private api: ApiService, private permissionService: PermissionsService) { }
  ngOnInit(): void {
    this.eoiForm = this.fb.group({
      comment: ['', Validators.required],
      comment_2: ['', Validators.required],

    });
    this.sotrForm = this.fb.group({
      comment: ['', Validators.required],
    });
    this.socForm = this.fb.group({
      comment: ['', Validators.required],
    });
    this.rfpForm = this.fb.group({
      comment: ['', Validators.required],
    });
    this.stepForm = this.fb.group({
      comment: [''],
    });
    this.ongetEOI();

  }



  addRow() {
    this.reqDoc.push({
      srNo: this.reqDoc.length + 1,
      name: '',
      edit: true,

    });
  }
  totalRecords: number = 0;
  ongetEOI(event: { page: number; search?: string } = { page: 1 }) {
    const page = event.page || 1;
    const search = event.search?.trim();

    let url = `/master/master-data/?page=${page}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    this.api.getAPI(url).subscribe((res: any) => {
      this.EOIData = res.results;
      this.EOIData = this.EOIData?.map(item => ({
        id: item.id,
        name: item.name,
        paragraph_1: item.paragraph_1,
        paragraph_2: item.paragraph_2,
        criteria_list: JSON.stringify(item.criteria_list, null, 2),
        file: item.file
      }));
      this.data = [...this.EOIData]
      this.totalRecords = res.results.length
    });
  }
  // onFormsubmit() {
  //   let payload: any = {};
  //   const type = this.selectedType?.value;

  //   switch (type) {
  //     case 'eoi':
  //       if (this.eoiForm.valid) {
  //         payload = {
  //           name: 'EOI',
  //           paragraph_1: this.eoiForm.get('comment')?.value || '',
  //           paragraph_2: this.eoiForm.get('comment_2')?.value || '',
  //           criteria_list: this.reqDoc.map(item => {
  //             // Customize logic if `item.name` holds structured JSON text
  //             try {
  //               return JSON.parse(item.name); // if name is a JSON string
  //             } catch {
  //               return { name: item.name }; // fallback to plain string
  //             }
  //           })
  //         };
  //       }
  //       break;

  //     case 'soc':
  //       if (this.socForm.valid) {
  //         payload = {
  //           name: 'SOC',
  //           paragraph_1: this.socForm.get('comment')?.value
  //         };
  //       }
  //       break;

  //     case 'sotr':
  //       if (this.sotrForm.valid) {
  //         payload = {
  //           name: 'SOTR',
  //           paragraph_1: this.sotrForm.get('comment')?.value
  //         };
  //       }
  //       break;

  //     case 'rfp':
  //       if (this.rfpForm.valid) {
  //         payload = {
  //           name: 'RFP',
  //           paragraph_1: this.rfpForm.get('comment')?.value
  //         };
  //       }
  //       break;

  //     default:
  //       console.warn('No valid document type selected');
  //       return;
  //   }
  //   if (this.editMode) {
  //     this.api.putAPI(`/master/master-data/${this.selectedItem.id}/`, payload).subscribe((res: any) => {
  //       //console.log(res)
  //       this.editMode = false;
  //       this.ongetEOI();
  //       this.eoiForm.reset();
  //       this.socForm.reset();
  //       this.sotrForm.reset();
  //       this.rfpForm.reset();
  //     });
  //   } else {
  //     this.api.postAPI(`/master/master-data/`, payload).subscribe((res: any) => {
  //       //console.log(res)
  //       this.showDialog = false;
  //       this.ongetEOI();
  //       this.eoiForm.reset();
  //       this.socForm.reset();
  //       this.sotrForm.reset();
  //       this.rfpForm.reset();
  //     });
  //   }
  // }

  // updateSystem(data: any) {
  //   this.eoiForm.reset();
  //   this.socForm.reset();
  //   this.sotrForm.reset();
  //   this.rfpForm.reset();
  //   this.selectedItem = data
  //   if (data.name === 'EOI') {
  //     this.selectedType = { label: 'EOI', value: 'eoi' }; // to show the EOI section
  //     this.editMode = true;

  //     // Patch the form
  //     this.eoiForm.patchValue({
  //       comment: data.paragraph_1,
  //       comment_2: data.paragraph_2
  //     });

  //     // Check and parse criteria_list if needed
  //   let parsedCriteria = [];

  //   if (typeof data.criteria_list === 'string') {
  //     try {
  //       parsedCriteria = JSON.parse(data.criteria_list);
  //     } catch (err) {
  //       console.error('Failed to parse criteria_list:', err);
  //       parsedCriteria = [];
  //     }
  //   } else if (Array.isArray(data.criteria_list)) {
  //     parsedCriteria = data.criteria_list;
  //   }
  //   // Combine all values from objects into one string
  //   const combinedText = parsedCriteria
  //     .map(obj => Object.values(obj)[0])
  //     .filter(val => !!val)
  //     .join(', ');


  //   // Add edit property for UI table
  //   this.reqDoc = [{
  //     name: combinedText,
  //     edit: false
  //   }];
  //   } else if (data.name === 'SOTR') {
  //     this.selectedType = { label: 'SOTR', value: 'sotr' }; // to show the EOI section
  //     this.editMode = true;

  //     // Patch the form
  //     this.sotrForm.patchValue({
  //       comment: data.paragraph_1,
  //     });
  //   }
  //   else if (data.name === 'SOC') {
  //     this.selectedType = { label: 'SOC', value: 'soc' }; // to show the EOI section
  //     this.editMode = true;

  //     // Patch the form
  //     this.socForm.patchValue({
  //       comment: data.paragraph_1,
  //     });
  //   }
  //   else if (data.name === 'RFP') {
  //     this.selectedType = { label: 'RFP', value: 'rfp' }; // to show the EOI section
  //     this.editMode = true;

  //     // Patch the form
  //     this.rfpForm.patchValue({
  //       comment: data.paragraph_1,
  //     });
  //    }
  // }

  // addSystem() {
  //   this.eoiForm.reset();
  //   this.socForm.reset();
  //   this.sotrForm.reset();
  //   this.rfpForm.reset();
  //   this.selectedType = { label: '', value: '' }
  //   this.showDialog = true;
  // }
  uploadedFileName: string = '';
  file: File;
  selectedFinalOfferFile: File | null = null;
  finalOfferFilePath: string | null = null;
  apiUrl = environment.APIUrl;
  onUpload(event: any): void {
    const file = event.files?.[0];
    this.file = file;
    if (!file) return;
    this.selectedFinalOfferFile = file;
  }
  extractFileName(path: string): string {
    return path.split('/').pop() || path;
  }

  clearUpload() {
    this.selectedFinalOfferFile = null;
    this.file = null;
    if (this.fileUpload) {
      this.fileUpload.clear();
      this.fileUpload.files = [];
      this.fileUpload['_fileInput'].nativeElement.value = '';
    }
    if (this.editFileUpload) {
      this.editFileUpload.clear();
      this.editFileUpload.files = [];
      this.editFileUpload['_fileInput'].nativeElement.value = '';
    }
  }
  onFormsubmit() {
    const formData = new FormData();
    formData.append('name', this.selectedType.label);
    if (this.selectedFormat === 'editor' && this.stepForm?.get('comment')?.value) {
      formData.append('paragraph_1', this.stepForm.get('comment')?.value ?? '');
    }
    if (this.file) {
      formData.append('file', this.file);
    }


    if (this.selectedItem?.id) {
      this.api.putAPI(`/master/master-data/${this.selectedItem?.id}/`, formData).subscribe((res: any) => {
        this.finalOfferFilePath = res?.file || null;
        this.selectedFinalOfferFile = null;
        this.selectedType = null;
        this.editMode = false;
        this.showDialog = false;
        this.clearUpload();
        this.editFileUpload?.clear();
        this.ongetEOI();
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Data updated successfully' });

      });
    } else {
      this.api.postAPI(`/master/master-data/`, formData).subscribe((res: any) => {
        this.showDialog = false;
        this.editMode = false;
        this.selectedFinalOfferFile = null;
        this.selectedType = null
        this.finalOfferFilePath = res?.file || null;
        this.fileUpload?.clear();
        this.ongetEOI();
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Data  uploaded successfully' });
      });
    }
  }
   viewMode = false;
  viewSystem(rowData: any) {
    this.viewMode = true;
    if (rowData && rowData.id) {
      this.selectedItem = rowData;
      this.editMode = true;
      this.selectedFinalOfferFile = null;
      this.selectedType = this.documentTypes.find(x => x.value === rowData.name?.toLowerCase());
      this.finalOfferFilePath = rowData.file;
      this.finalOfferFileName = this.extractFileName(rowData?.file);
      this.fileUpload?.clear();
      this.editFileUpload?.clear();
      // Set format from existing data: editor if paragraph_1, else document if file
      if (rowData.paragraph_1) {
        this.selectedFormat = 'editor';
        this.stepForm?.patchValue({ comment: rowData.paragraph_1 });
      } else if (rowData.file) {
        this.selectedFormat = 'document';
        this.stepForm?.patchValue({ comment: '' });
      } else {
        this.selectedFormat = null;
      }
    }
  }
  finalOfferFileName: string | null = null;
  updateSystem(data: any) {
    this.viewMode = false;
    this.editMode = true;
    this.selectedItem = data;
    this.selectedFinalOfferFile = null;
    this.selectedType = this.documentTypes.find(x => x.value === data.name?.toLowerCase());
    this.finalOfferFilePath = data.file;
    this.finalOfferFileName = this.extractFileName(data?.file);
    this.fileUpload?.clear();
    this.editFileUpload?.clear();
    // Set format from existing data: editor if paragraph_1, else document if file
    if (data.paragraph_1) {
      this.selectedFormat = 'editor';
      this.stepForm?.patchValue({ comment: data.paragraph_1 });
    } else if (data.file) {
      this.selectedFormat = 'document';
      this.stepForm?.patchValue({ comment: '' });
    } else {
      this.selectedFormat = null;
    }
  }

  /** Called when Edit/View dialog is shown – syncs editor content after TinyMCE is in DOM so data shows when opening via Edit first. */
  onEditDialogShow(): void {
    if (!this.editMode || !this.selectedItem) return;
    if (this.selectedFormat === 'editor' && this.selectedItem.paragraph_1) {
      // Defer patch so the editor is rendered and TinyMCE has initialized; then data shows in both View and Edit
      setTimeout(() => {
        this.stepForm?.patchValue({ comment: this.selectedItem.paragraph_1 });
      }, 100);
    }
  }

  addSystem() {
    this.selectedType = { label: '', value: '' };
    this.showDialog = true;
    // Reset file variables
    this.selectedFinalOfferFile = null;
    this.selectedItem = null;
    this.finalOfferFilePath = '';
    // Reset format selection and editor state when opening Create dialog
    this.selectedFormat = null;
    this.editorContent = '';
    this.stepForm?.reset({ comment: '' });

    // If you're using a file upload component with a template reference variable
    if (this.fileUpload) {
      this.fileUpload.clear(); // clear file UI
    }

  }
  showDeletePopup(equipment: any) {
    this.showDeleteDialog = true;
    this.selectedItem = equipment
  }
  deleteequipment() {
    // this.selectedequipment = equipment;
    let sectionId = this.selectedItem.id
    this.api.deleteAPI(`/master/master-data/${sectionId}/`).subscribe({
      next: (res: any) => {
        //console.log(res);
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Master data deleted Successfully',
        });
        this.showDeleteDialog = false
        this.ongetEOI()
      },
      error: (err) => {
        console.error('API Error:', err);
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Error',
        //   detail: 'Failed to delete the proposal. Please try again.',
        // });
      },
    });

  }
  get canEditSetup(): boolean {
    return this.permissionService.hasPrivilege('/master/data-master', 'Edit') ||
      this.permissionService.hasPrivilege('/master/data-master', 'Delete')||
      this.permissionService.hasPrivilege('/master/data-master', 'View');
  }
}
